export const name = "LPAD";
export const summary = `Prepends a \`STRING\` or \`BYTES\` value with a pattern.`;
export const reference = `
## LPAD

Prepends a \`STRING\` or \`BYTES\` value with a pattern.

\`\`\`
LPAD(original_value, return_length[, pattern])
\`\`\`

### Description

Returns a \`STRING\` or \`BYTES\` value that consists of \`original_value\` prepended with \`pattern\`. The \`return_length\` is an \`INT64\` that specifies the length of the returned value. If \`original_value\` is of type\`BYTES\`, \`return_length\` is the number of bytes. If \`original_value\` is of type \`STRING\`, \`return_length\` is the number of characters.

The default value of \`pattern\` is a blank space.

Both \`original_value\` and \`pattern\` must be the same data type.

If \`return_length\` is less than or equal to the \`original_value\` length, this function returns the \`original_value\` value, truncated to the value of\`return_length\`. For example, \`LPAD('hello world', 7);\` returns \`'hello w'\`.

If \`original_value\`, \`return_length\`, or \`pattern\` is \`NULL\`, this function returns \`NULL\`.

This function returns an error if:

- \`return_length\` is negative
- \`pattern\` is empty


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT FORMAT('%T', LPAD('c', 5)) AS results

/*---------*
 | results |
 +---------+
 | " c" |
 *---------*/
\`\`\`



\`\`\`
SELECT LPAD('b', 5, 'a') AS results

/*---------*
 | results |
 +---------+
 | aaaab |
 *---------*/
\`\`\`



\`\`\`
SELECT LPAD('abc', 10, 'ghd') AS results

/*------------*
 | results |
 +------------+
 | ghdghdgabc |
 *------------*/
\`\`\`



\`\`\`
SELECT LPAD('abc', 2, 'd') AS results

/*---------*
 | results |
 +---------+
 | ab |
 *---------*/
\`\`\`



\`\`\`
SELECT FORMAT('%T', LPAD(b'abc', 10, b'ghd')) AS results

/*---------------*
 | results |
 +---------------+
 | b"ghdghdgabc" |
 *---------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
